import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HioShareBasicService {
  public onFocusInputSelectValue = true;
  constructor() { }
}
